import { render, staticRenderFns } from "./TermsAndConditionsUsa.vue?vue&type=template&id=10da3c68&scoped=true"
import script from "./TermsAndConditionsUsa.vue?vue&type=script&lang=js"
export * from "./TermsAndConditionsUsa.vue?vue&type=script&lang=js"
import style0 from "./TermsAndConditionsUsa.vue?vue&type=style&index=0&id=10da3c68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10da3c68",
  null
  
)

export default component.exports